<template>
  <div>
    <h4 class="blue-grey--text text--lighten-1">{{ item.title }}</h4>
    <span style="font-size: 15px;" v-html="item.content"></span>
  </div>
</template>

<script>
  export default {
    name: 'PolicyItem',

    props: {
      item: { type: Object }
    }
  }
</script>

<style lang="scss" scoped>

</style>